import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiChevronLeft, FiChevronRight, FiPause, FiPlay } = FiIcons;

function CarouselControls({
  currentIndex,
  isPlaying,
  onPrevious,
  onNext,
  onToggle,
  onSelect,
  total,
  disabled = false,
  reducedMotion = false
}) {
  return (
    <div className="carousel-controls" aria-label="Carousel controls">
      <div className="arrow-controls">
        <button className="control-button" type="button" onClick={onPrevious} disabled={disabled} aria-label="Previous cover">
          <SafeIcon icon={FiChevronLeft} aria-hidden="true" />
        </button>
        <button className="control-button" type="button" onClick={onNext} disabled={disabled} aria-label="Next cover">
          <SafeIcon icon={FiChevronRight} aria-hidden="true" />
        </button>
      </div>
      <div className="dot-controls" aria-label="Choose episode cover">
        {Array.from({ length: total }, (_, index) => (
          <button
            className={`dot ${index === currentIndex ? 'is-active' : ''}`}
            type="button"
            aria-label={`Show cover ${index + 1} of ${total}`}
            aria-current={index === currentIndex ? 'true' : undefined}
            key={index}
            onClick={() => onSelect(index)}
          />
        ))}
      </div>
      <button
        className="control-button play-control"
        type="button"
        onClick={onToggle}
        disabled={disabled || reducedMotion}
        aria-label={reducedMotion ? 'Autoplay unavailable with reduced motion' : isPlaying ? 'Pause carousel' : 'Play carousel'}
      >
        <SafeIcon icon={isPlaying ? FiPause : FiPlay} aria-hidden="true" />
      </button>
    </div>
  );
}

export default CarouselControls;